import { WEB_COMPONENT_WEB_ACCESS_CONTROL_CUSTOM_PAGES_APP } from '../../webcomponents.constants';
import { WebAccessControlCustomPagesComponent } from './component/WebAccessControlCustomPagesComponent';

/**
 * The component for displaying the Web Access Control Pages (WAC Pages)
 * @link
 */
export { WebAccessControlCustomPagesComponent };
window.customElements.define(WEB_COMPONENT_WEB_ACCESS_CONTROL_CUSTOM_PAGES_APP, WebAccessControlCustomPagesComponent);
